/**
* Exponea/Bloomreach Script will enabled based on Country code
* _is_bloomreach_tags_enabled_ will enable/disable the script load
* sending email_id to identify the user
* login track event for timestamp,Available Product List , country name and domain
*/
export const loginEventTrack = (country_code: string, email_id: string, available_product_list: string[], flow: string):void => {
    try {
        if (country_code === 'US') {
            window._is_bloomreach_tags_enabled_ = true;
            setTimeout(() => {
                window.exponea?.identify({ email_id: email_id.toLowerCase().trim() });
                const countryNameByCodeObject = new Intl.DisplayNames(['en'], { type: 'region' });
                window.exponea?.track('login', {
                    timestamp: Math.floor(Date.now() / 1000),
                    available_product_list,
                    country: countryNameByCodeObject.of(country_code),
                    domain: window.location.hostname,
                    flow
                });
            }, 3000);
        }
        else {
            window._is_bloomreach_tags_enabled_ = false;
        }
    }
    catch (err) {
        console.log(`Error in bloomreach loginEventTrack ${err}`);
    }
};

/**
* Product Launch  event will track timestamp,product_name, country name and domain
*/
export const productLaunchEventTrack = (country_code: string, heading: string):void => {
    try {
        const countryNameByCodeObject = new Intl.DisplayNames(['en'], { type: 'region' });

        window.exponea?.track('product_launch', {
            timestamp: Math.floor(Date.now() / 1000),
            product_name: heading,
            country: countryNameByCodeObject.of(country_code),
            domain: window.location.hostname
        });
    }
    catch (err) {
        console.log(`Error in bloomreach productLaunchEventTrack ${err}`);
    }
};

/**
* Exponea/Bloomreach Script will enabled based on Country code
* _is_bloomreach_tags_enabled_ will enable/disable the script load
* sending email_id, email, first_name, last_name to identify the user
* New Customer track event for action,category,valid_until, message,location,domain,language
*/
export const newCustomerEventTrack = (country_code: string, email_id: string, first_name:string, last_name:string, consent:string, phoneNumber:string,):void => {
    try {
        if (country_code === 'US') {
            window._is_bloomreach_tags_enabled_ = true;
            const searchParams = (new URL(window.location.href)).searchParams;
            const isDunsNumberExist = !!searchParams.get('flow') && !!searchParams.get('dunsNumber');
            setTimeout(() => {
                window.exponea?.identify({ email_id: email_id.toLowerCase().trim() });
                window.exponea?.update({
                    email: email_id.toLowerCase().trim(), first_name, last_name, phoneNumber
                });
                const locale = new Intl.Locale(navigator.language);
                window.exponea?.track('consent', {
                    action: 'accept',
                    category: 'Marketing',
                    valid_until: 'unlimited',
                    message: consent,
                    location: window.location.href,
                    domain: window.location.hostname,
                    language: locale.language,
                    placement: isDunsNumberExist ? 'Associate-a-DUNS' : 'New Customer'
                });
            }, 3000);
        }
        else {
            window._is_bloomreach_tags_enabled_ = false;
        }
    }
    catch (err) {
        console.log(`Error in bloomreach newCustomerEventTrack  ${err}`);
    }
};

export const lendioEventTrack = (deviceName:string):void => {
    try {
        window._is_bloomreach_tags_enabled_ = true;
        setTimeout(() => {
            window.exponea?.track('ad_click', {
                device: deviceName, action: 'click', interaction: true, ad_company: 'Lendio'
            });
        }, 3000);
    }
    catch (err) {
        console.log(`Error in bloomreach lendioEventTrack ${err}`);
    }
};
